import React from 'react';
import '../../TestView/styles.scss';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import strings from '../../../utils/strings';
import {Link} from 'react-router-dom';
import handBookPdf from '../../../assets/DysmateHåndbok_v1.1_compressed.pdf';
import {
	CHILD_SCRNG_TEST_STEP_IDS,
	YOUTH_TEST_STEP_IDS,
} from '../../../constants';
import {getPronoun} from '../../../utils/getPronouns';
import {formateTestName} from '../../../utils/formatTestName';

const TESTS_REQUIRED_TO_PASS = 3;

class Assessment extends React.Component {
	constructor(props) {
		super(props);
	}

	// eslint-disable-next-line complexity
	render() {
		const {testResult, completeName, firstName} = this.props;
		const subtestsLength = testResult.subtests.length;
		const allLowZscores = {};

		let zScoreLowCount = 0;
		let writeUpText;
		let writeUpTextHeaderNote = '';
		let writeUpTextFootNote = '';
		let clearlyBelowZScoreCount = 0;
		let significantlyBelowZScoreCount = 0;
		let withInZScoreCount = 0;
		let clearlyAboveZScoreCount = 0;
		let testType;
		let stringForLowScoreInTwoSubtest;
		let assessmentMainHeading = strings.assessmentscreening;

		if (testResult.type === 'child-screening') {
			assessmentMainHeading = strings.assessmentChildScreening;
			testType = CHILD_SCRNG_TEST_STEP_IDS;
			stringForLowScoreInTwoSubtest = strings.formatString(
				strings.localizedwriteuptextforLowScoreOfBetyledeWithOneOtherSubTest,
				`${getPronoun(testResult.testUser.gender)}`
			);
		} else {
			testType = YOUTH_TEST_STEP_IDS;
			stringForLowScoreInTwoSubtest = strings.formatString(
				strings.localizedwriteuptextforLowScoreOfOrdiktatWithOneOtherSubTest,
				`${firstName}`
			);
		}

		const findTestResult = testResult.subtests?.find((subtest) => {
			let subTestType;

			if (testType === CHILD_SCRNG_TEST_STEP_IDS) {
				subTestType = CHILD_SCRNG_TEST_STEP_IDS.BYTTELYDTESTEN;
			} else {
				subTestType = YOUTH_TEST_STEP_IDS.ORDDIKTAT;
			}
			return subtest.id === subTestType;
		});

		testResult.subtests.forEach((subtest) => {
			if (subtest) {
				const {id, zScore} = subtest;
				if (zScore < -1) {
					zScoreLowCount++;
					allLowZscores[id] = zScore;
				}
				if (zScore > -2.0 && zScore < -1.01) {
					clearlyBelowZScoreCount++;
				} else if (zScore < -2.01) {
					significantlyBelowZScoreCount++;
				} else if (zScore > -1.0 && zScore < 1.0) {
					withInZScoreCount++;
				} else if (zScore > 1.01) {
					clearlyAboveZScoreCount++;
				}
			}
		});

		//maps test names with Zscores

		const allLowZscoresTestsWithNames = {};
		for (const [key, value] of Object.entries(testType)) {
			if (allLowZscores[value] !== undefined) {
				allLowZscoresTestsWithNames[key] = allLowZscores[value];
			}
		}
		const keys = Object.keys(allLowZscoresTestsWithNames);
		//if the the test is incomplete
		if (testResult.completedAt === null) {
			writeUpText = strings.formatString(
				strings.localizedwriteuptextforIncompletedTest,
				`${completeName}`
			);
		} else if (
			testResult.type !== 'child-screening' &&
			zScoreLowCount === 2 &&
			allLowZscoresTestsWithNames.hasOwnProperty('ORDFORSTÅELSE') &&
			allLowZscoresTestsWithNames.hasOwnProperty('LESEPRØVEN')
		) {
			writeUpTextHeaderNote =
				testResult.type === 'child-screening'
					? strings.assesmentgeneralChild
					: strings.assesmentgeneral;
			writeUpText = strings.formatString(
				strings.localizedwriteuptextforLowScoreInLeseprovenAndOrdforstaelse,
				significantlyBelowZScoreCount || clearlyBelowZScoreCount
					? `${completeName} erzielt bei ${
							significantlyBelowZScoreCount +
							clearlyBelowZScoreCount
						} der sechs Subtests (stark) unterdurchschnittliche Ergebnisse. `
					: '',
				withInZScoreCount > 0 || clearlyAboveZScoreCount > 0
					? `Bei den übrigen Untertests erzielt ${completeName} Ergebnisse, die im 
					oder über dem Durchschnitt liegen.`
					: '',

				`${getPronoun(testResult.testUser.gender)}`
			);
			writeUpTextFootNote = (
				<span>
					<b>Achtung:</b>
					{
						strings.localizedwriteuptextforLowScoreInLeseprovenAndOrdforstaelseFootnote
					}
				</span>
			);
		} else if (findTestResult?.zScore <= -1 || zScoreLowCount >= 1) {
			//if the zscore are low in betelid test for child and ordiktat for youth and adult (only implemented for special case)
			switch (true) {
				//if only one tests have low zscores (betelid or ordiktat)
				case zScoreLowCount === 1:
					writeUpTextHeaderNote =
						testResult.type === 'child-screening'
							? strings.assesmentgeneralChild
							: strings.assesmentgeneral;
					writeUpText = strings.formatString(
						strings.localizedwriteuptextforNormalresults,
						`${completeName}`,
						`${getPronoun(testResult.testUser.gender)}`
					);
					break;
				//if only two tests have low zscores
				case zScoreLowCount === 2:
					writeUpTextHeaderNote =
						testResult.type === 'child-screening'
							? strings.assesmentgeneralChild
							: strings.assesmentgeneral;
					writeUpText = strings.formatString(
						strings.localizedwriteuptextforNormalresults,
						`${completeName}`,
						`${getPronoun(testResult.testUser.gender)}`
					);
					break;
				//if only three tests have low zscores
				case zScoreLowCount === 3:
					writeUpTextHeaderNote =
						testResult.type === 'child-screening'
							? strings.assesmentgeneralChild
							: strings.assesmentgeneral;
					writeUpText = strings.formatString(
						strings.localizedwriteuptextforTwoOtherSubTest,

						significantlyBelowZScoreCount || clearlyBelowZScoreCount
							? `${completeName} erzielt bei ${
									significantlyBelowZScoreCount +
									clearlyBelowZScoreCount
								} der sechs Subtests (stark) 
							unterdurchschnittliche Ergebnisse.`
							: '',
						withInZScoreCount > 0 || clearlyAboveZScoreCount > 0
							? `Bei den übrigen Subtests erzielt ${completeName} Ergebnisse, die im oder (stark) über dem 
							Durchschnitt liegen.`
							: '',

						`${getPronoun(testResult.testUser.gender)}`,
						`${formateTestName(keys[0])}`,
						`${formateTestName(keys[1])}`,
						`${formateTestName(keys[2])}`
					);
					break;
				//if more than three tests have low zscores
				case zScoreLowCount > 3:
					if (
						zScoreLowCount === 6 ||
						zScoreLowCount === 5 ||
						zScoreLowCount === 4
					) {
						writeUpTextHeaderNote =
							testResult.type === 'child-screening'
								? strings.assesmentgeneralChild
								: strings.assesmentgeneral;
						const lastElement = keys[keys.length - 1];
						writeUpText = strings.formatString(
							strings.localizedwriteuptextforThreeORMoreOtherSubTest,

							significantlyBelowZScoreCount ||
								clearlyBelowZScoreCount
								? `${completeName} erzielt bei ${
										significantlyBelowZScoreCount +
										clearlyBelowZScoreCount
									} der sechs Subtests (stark) 
								unterdurchschnittliche Ergebnisse.`
								: '',
							withInZScoreCount > 0 || clearlyAboveZScoreCount > 0
								? `Bei den übrigen Subtests erzielt ${completeName} Ergebnisse, die im oder (stark) über dem 
								Durchschnitt liegen.`
								: '',

							`${getPronoun(testResult.testUser.gender)}`,
							`${formateTestName(keys[0])}`,
							`${formateTestName(keys[1])}`,
							`${formateTestName(keys[2])}`,
							// eslint-disable-next-line no-nested-ternary
							keys[3]
								? keys[3] === lastElement
									? `und ${formateTestName(keys[3])}`
									: `, ${formateTestName(keys[3])}`
								: '',
							// eslint-disable-next-line no-nested-ternary
							keys[4]
								? keys[4] === lastElement
									? `und ${formateTestName(keys[4])}`
									: `, ${formateTestName(keys[4])}`
								: '',
							// eslint-disable-next-line no-nested-ternary
							keys[5]
								? keys[5] === lastElement
									? `und ${formateTestName(keys[5])}`
									: `, ${formateTestName(keys[5])}`
								: ''
						);
					}
					break;
			}
		} else {
			//if the zscores are in normal range
			writeUpTextHeaderNote =
				testResult.type === 'child-screening'
					? strings.assesmentgeneralChild
					: strings.assesmentgeneral;
			writeUpText = strings.formatString(
				strings.localizedwriteuptextforFullyNormalresults,
				`${completeName}`,
				`${getPronoun(testResult.testUser.gender)}`
			);
		}
		return (
			<div className="sub-test__scores">
				<div className="width--half center">
					<h4 className="sub-test__heading big">
						{assessmentMainHeading}
					</h4>
					<p>{writeUpTextHeaderNote}</p>
					<p>{writeUpText}</p>
					<p>{writeUpTextFootNote}</p>
				</div>
			</div>
		);
	}
}

Assessment.propTypes = {
	currentUser: PropTypes.shape({}),
};

const mapStateToProps = (state) => {
	const {currentUser} = state;

	return {
		currentUser,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Assessment);
